import cfg, {handleResponse, handlePrepareData} from "../constants";
import {authMiddleware} from "./loginAction";

export const foodProductsAction = (body) => (dispatch, getState) => {
  const headers = authMiddleware(dispatch, getState);
  return fetch(cfg.base_url + '/auth/food-products', {
    method: "POST",
    headers: headers,
    body: JSON.stringify(body)
  }).then(handleResponse).then(handlePrepareData);
};

